export default __webpack_public_path__ + "assets/images/h-quote-icon-5b091ec0.svg";